module.exports = __webpack_public_path__ + "img/homepage_2--mobile.85905074.jpg";